<template>
  <div class="virtual-wrap">
    <div class="virtual-main">
      <div v-for="img in imglist" :key="img" class="virtualTop">
        <img v-lazy="img" />
      </div>
      <div class="paddingDiv">&emsp;</div>
      <van-dialog v-model="successVisible">
        <p style=" text-align:center;padding:30px 20px;width:100%">已上架到团小蜜！快去小程序中查看吧~</p>
      </van-dialog>
      <van-dialog v-model="centerDialogVisible">
        <p
          style="text-align:center;padding:30px 20px;width:100%;"
        >您还不是团长，添加微信「pursue5998」申请成为我们的团长吧！</p>
      </van-dialog>
    </div>
    <div class="virtual-footer" @click="oneKeyRack" id="footer">{{text}}</div>
  </div>
</template>

<script>
import axios from "axios";
import configUrl from "../config/config.js";
import wx from "weixin-js-sdk";
export default {
  mixins: [configUrl],
  data() {
    return {
      goodId: "",
      goodPic: [],
      centerDialogVisible: false,
      successVisible: false,
      text: "一键上架",
      goodName: "",
      sharePic: "",
      state: "",
      imglist: [],
      desc: ""
    };
  },

  methods: {
    getGood(callback) {
      axios
        .post(this.getDomain() + "goods/get_detail", {
          good_id: this.goodId
        })
        .then(res => {
          if (res.data.err_code === 0) {
            callback(res);
            let desc = this.getDesc();
            this.wx_jssdk(this.goodId, this.sharePic, this.goodName, desc);
            document.title = this.goodName;
          }
        });
    },
    oneKeyRack() {
      if (this.text !== "一键上架") {
        return;
      }
      let url =
        this.getRedirectDomain() +
        `classify/#/Virtualdetail?good_id=${this.goodId}`;
      let curUrl = url.replace("#", "%23");
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe10d406d3c94eded&redirect_uri=${curUrl}&response_type=code&scope=snsapi_userinfo&state=${this.goodName}#wechat_redirect`;
    },
    addGroupBuy(code) {
      axios
        .post(this.getDomain() + "goods/add_group_buy", {
          good_id: this.goodId,
          code: code
        })
        .then(res => {
          if (res.data.err_code === 0) {
            if (res.data.content.is_client === 1) {
              // 是团长
              this.successVisible = true;
            } else {
              //是团长  已经添加到小程序
              this.centerDialogVisible = true;
            }
          } else if (res.data.err_code === 20114) {
            this.text = res.data.content.desc;
            document.getElementById("footer").style.backgroundColor = "#ccc";
          }
        });
    },
    wx_jssdk(goodId, sharePic, goodName, desc) {
      axios
        .post(this.getDomain() + "wx/get_signature", {
          url: window.location.href
        })
        .then(function(response) {
          if (response.data.err_code === 0) {
            wx.config({
              debug: false,
              appId: "wxe10d406d3c94eded",
              timestamp: response.data.content.timestamp,
              nonceStr: response.data.content.noncestr,
              signature: response.data.content.signature,
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData"
              ]
            });
            wx.ready(function() {
              wx.updateAppMessageShareData({
                title: goodName,
                desc: desc,
                link:
                  "https://wxtxm.zidouchat.com/classify/?no_cache=" +
                  Math.random() +
                  "#/Virtualdetail?good_id=" +
                  goodId,
                imgUrl: sharePic,
                success: function() {}
              });
              wx.updateTimelineShareData({
                title: goodName,
                desc: desc,
                link:
                  "https://wxtxm.zidouchat.com/classify/?no_cache=" +
                  Math.random() +
                  "#/Virtualdetail?good_id=" +
                  goodId,
                imgUrl: sharePic,
                success: function() {}
              });
            });
          }
        });
    },
    getGoodCallback(res) {
      this.imglist = res.data.content.detail_info.detail_pic_list;
      this.sharePic = res.data.content.detail_info.goods_pic;
      this.goodName = res.data.content.detail_info.name;
    },
    getDesc() {
      let goodName = this.goodName;
      if (
        goodName.indexOf("花生音乐") > -1) {
        return this.desc = "你的孩子不要被补习班压垮，培养多才多艺小明星来石家庄花生音乐，少儿声乐培训班0元体验5节课，吉他、流行演奏任你选。";
      } else if (goodName.indexOf("阿凡题") > -1) {
        return this.desc = "名师定制1对1课程，限时免费试听，针对初三到高三的学生，以“高考考点”为最小单元学习，各个科目全部涵盖。";
      } else if (goodName.indexOf("伴鱼") > -1) {
        return this.desc = "欧美好外教，在线一对一，超高性价比。伴鱼少儿英语，让孩子学英语更有效！";
      }
    }
  },
  created() {
    this.goodId = this.$route.query.good_id;
    if (!this.goodId) {
      // TODO: 给一个 error 提示
      return;
    }

    let cUrl = window.location.href;
    if (cUrl.indexOf("code") > -1) {
      let code = cUrl.split("code=")[1].split("&state")[0];
      if (code) {
        this.addGroupBuy(code);
      }
    }
    this.getGood(this.getGoodCallback);
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
body,
html {
  width: 100%;
  height: 100%;
  position: relative;
}
.virtual-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.virtual-main {
  flex: 1;
  max-width: 7.5rem;
  background: rgba(255, 255, 255, 1);
  .virtualTop {
    width: 100%;
    height: 100%;
    display: block;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .virtualTop:last-child {
    padding-bottom: 2rem;
  }
}
.virtual-footer {
  width: 100%;
  height: 1.12rem;
  background: rgba(203, 41, 46, 1);
  text-align: center;
  line-height: 1.12rem;
  color: white;
  font-weight: 500;
  font-size: 0.36rem;
  position: fixed;
  bottom: 0;
  left: 0;
}
.paddingDiv {
  width: 100%;
  height: 1.5rem;
  padding-bottom: 0.9rem;
  opacity: 0;
  // border-radius:
}
.el-dialog {
  border-radius: 30px;
}
.el-dialog__header {
  padding-bottom: 0;
}
.el-dialog--center .el-dialog__body {
  padding: 0px 25px 30px !important;
}
</style>
<style lang="scss">
.el-dialog--center .el-dialog__body {
  padding: 0px 25px 30px !important;
}
</style>

